import React, { Component } from "react";
import LoadingWindow from '../../components/LoadingWindow';
import { create_Delete_Update_Information, getInformationWithData } from "../../services/CABE";
import { BsFileArrowUpFill, BsFileArrowDownFill, BsPercent } from "react-icons/bs";
import { AiOutlineReload, AiOutlineSearch } from "react-icons/ai";
import "../../css/general-style.css";
import "../../css/dashboard.css";
import { getIndexElement } from "../../functions/searchInObject";
import { pricesFormat } from "../../functions/pricesFormat";
import { confirmCloseAlert } from "../../functions/alerts";
import ExcelDocument from "../../components/ExcelDocument";
import { getDataSetProductLineMargin } from "../../functions/generateDataSetExcel";
import { getValueCookie } from "../../services/cookieService";
import { getDateFromReports } from "../../functions/dateFormat";
import { OrderArray } from "../../functions/generalFunctions";
import { Menu } from "../../components/Menu/Menu";

export default class PriceMarginProdLine extends Component {
    constructor(props) {
        super(props)
        this.ModalLoading = React.createRef();
    }
    state = {
        FilterProductLines: [],
        ProductLines: [],
        order: true,
        search: '',
        activeLetter: 'All',
    }

    async getPriceMargins() {
        this.ModalLoading.current.showState(true);
        const result = await getInformationWithData('/Items/Margin/Alt', {})
        if (result.status.code === 1) {
            this.setState({ ProductLines: result.data, FilterProductLines: result.data, search: '', activeLetter: 'All' })
        }
        this.ModalLoading.current.showState(false);
    }

    Contains(parametro, busqueda) {
        if (parametro && busqueda) {
            return parametro.toString().toLowerCase().includes(busqueda.toLocaleLowerCase())
        }
        return false
    }

    applyFilters(search, letter, productLines) {
        let filtered = productLines || this.state.ProductLines
        if (search) {
            filtered = filtered.filter(d => this.Contains(d.ProductLineDesc, search))
        }
        if (letter && letter !== 'All') {
            filtered = filtered.filter(d => d.ProductLineDesc && d.ProductLineDesc[0].toUpperCase() === letter)
        }
        return filtered
    }

    handleSearch = async (e) => {
        const search = e.target.value
        this.setState({ search, FilterProductLines: this.applyFilters(search, this.state.activeLetter) })
        await this.refreshInputs()
    }

    handleLetterFilter = async (letter) => {
        this.setState({ activeLetter: letter, FilterProductLines: this.applyFilters(this.state.search, letter) })
        await this.refreshInputs()
    }

    refreshInputs() {
        for (const item of this.state.FilterProductLines) {
            const el = document.getElementById('priceMarginProdLine_' + item.ProductLineDesc)
            if (el) el.value = item.DiscountMarkup
        }
    }

    EnableMarginPrice(id) {
        const el = document.getElementById(id)
        if (el) el.removeAttribute('disabled')
    }

    changePriceMargin = async (e) => {
        if (e.key === 'Enter') {
            const id = e.target.id.split('_')
            if (id.length === 2) {
                const temporal = this.state.ProductLines
                const temporal2 = this.state.FilterProductLines
                const index = getIndexElement(temporal, 'ProductLineDesc', id[1])
                const index2 = getIndexElement(temporal2, 'ProductLineDesc', id[1])
                if (index !== -1) {
                    const data = { DiscountMarkup: Number(e.target.value), ProductLine: temporal[index].ProductLine }
                    const result = await create_Delete_Update_Information('/Items/Margin/Update/Alt', data)
                    if (result.status.code === 1) {
                        temporal[index].DiscountMarkup = pricesFormat(e.target.value)
                        temporal2[index2].DiscountMarkup = pricesFormat(e.target.value)
                        this.setState({ FilterProductLines: temporal2, ProductLines: temporal })
                        document.getElementById(e.target.id).setAttribute('disabled', 'disabled')
                        confirmCloseAlert('correct', 'Price Margin of: ' + id[1] + ' updated successfully!')
                    } else {
                        confirmCloseAlert('incorrect', 'Whoops, something is wrong. Try again!')
                    }
                }
            }
        }
    }

    async GeneralOrder(key, asc, name) {
        const temporal = this.state[name]
        const Order = OrderArray(temporal, key, asc)
        await this.setState({ [name]: Order, order: !asc })
        await this.refreshInputs()
    }

    getAvailableLetters() {
        const letters = new Set(
            this.state.ProductLines
                .filter(p => p.ProductLineDesc && p.ProductLineDesc[0])
                .map(p => p.ProductLineDesc[0].toUpperCase())
        )
        return ['All', ...Array.from(letters).sort()]
    }

    getMarginColor(val) {
        const n = Number(val)
        if (n >= 20) return { color: '#059669', bg: 'rgba(16,185,129,0.08)', border: '#A7F3D0' }
        if (n >= 10) return { color: '#D97706', bg: 'rgba(245,158,11,0.08)', border: '#FDE68A' }
        return { color: '#DC2626', bg: 'rgba(239,68,68,0.06)', border: '#FECACA' }
    }

    render() {
        const hasData = this.state.ProductLines.length > 0
        const letters = this.getAvailableLetters()
        const visible = this.state.FilterProductLines.filter(i => i.Visible !== 0)

        return (
            <div className="dash-page" style={{ paddingTop: '70px' }}>
                {this.props.showMenu && <Menu />}
                <LoadingWindow ref={this.ModalLoading} />

                {/* Hero */}
                <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #2563EB 100%)', padding: '1.25rem 2rem', display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                    <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '12px', padding: '0.75rem', display: 'flex' }}>
                        <BsPercent style={{ color: 'white', fontSize: '1.75rem' }} />
                    </div>
                    <div style={{ flex: 1 }}>
                        <h1 style={{ color: 'white', fontWeight: 800, fontSize: '1.375rem', margin: 0 }}>Price Margin by Product Line</h1>
                        <p style={{ color: 'rgba(255,255,255,0.6)', margin: 0, fontSize: '0.8rem' }}>
                            {hasData
                                ? `${visible.length} product lines · double-click a value to edit · Enter to save`
                                : 'Click Load to fetch current price margins'}
                        </p>
                    </div>
                    <div style={{ display: 'flex', gap: '0.625rem', alignItems: 'center' }}>
                        {hasData && (
                            <ExcelDocument
                                id={"ExcelProdLineMarginPrice"}
                                data={getDataSetProductLineMargin(this.state.ProductLines)}
                                sheetname={"Margin Price Product Lines"}
                                archname={"Margin Price Product Lines " + getValueCookie('Company') + " " + getDateFromReports()}
                            />
                        )}
                        <button onClick={() => this.getPriceMargins()}
                            style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '8px', color: 'white', fontWeight: 700, padding: '0.45rem 1rem', fontSize: '0.875rem', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}>
                            <AiOutlineReload /> Load
                        </button>
                    </div>
                </div>

                <div style={{ padding: '1.5rem 2rem' }}>
                    {!hasData ? (
                        <div style={{ textAlign: 'center', padding: '4rem 2rem', color: '#94A3B8' }}>
                            <BsPercent style={{ fontSize: '3rem', opacity: 0.2, marginBottom: '1rem' }} />
                            <p style={{ fontSize: '0.9rem', fontWeight: 500 }}>Click <strong>Load</strong> in the header to fetch current price margins.</p>
                        </div>
                    ) : (
                        <div className="card" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                            {/* Card header: search + letter pills */}
                            <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.875rem 1.25rem' }}>
                                {/* Search */}
                                <div style={{ position: 'relative', marginBottom: '0.75rem' }}>
                                    <AiOutlineSearch style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: 'rgba(255,255,255,0.5)', fontSize: '1rem' }} />
                                    <input
                                        value={this.state.search}
                                        onChange={this.handleSearch}
                                        placeholder="Search product line..."
                                        id="SearchMarginPriceProdLine"
                                        type="text"
                                        style={{ background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '8px', color: 'white', fontSize: '0.8125rem', padding: '0.35rem 0.75rem 0.35rem 2rem', width: '100%', outline: 'none' }}
                                    />
                                </div>
                                {/* Letter pills — like category pills in UsersManagement */}
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.3rem' }}>
                                    {letters.map(letter => {
                                        const isActive = this.state.activeLetter === letter
                                        const count = letter === 'All'
                                            ? this.state.ProductLines.length
                                            : this.state.ProductLines.filter(p => p.ProductLineDesc && p.ProductLineDesc[0].toUpperCase() === letter).length
                                        return (
                                            <button key={letter} onClick={() => this.handleLetterFilter(letter)}
                                                style={{ padding: '0.25rem 0.6rem', borderRadius: '6px', border: 'none', cursor: 'pointer', fontWeight: 700, fontSize: '0.78rem', background: isActive ? 'rgba(255,255,255,0.25)' : 'rgba(255,255,255,0.08)', color: isActive ? 'white' : 'rgba(255,255,255,0.6)', display: 'inline-flex', alignItems: 'center', gap: '0.25rem' }}>
                                                {letter}
                                                <span style={{ background: isActive ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.1)', borderRadius: '999px', padding: '0 4px', fontSize: '0.68rem' }}>{count}</span>
                                            </button>
                                        )
                                    })}
                                </div>
                            </div>

                            {/* Product lines grid — like module toggle cards in UsersManagement */}
                            <div style={{ padding: '1.25rem' }}>
                                {visible.length === 0 ? (
                                    <p style={{ textAlign: 'center', color: '#94A3B8', fontSize: '0.875rem', padding: '2rem 0' }}>No product lines match the current filter.</p>
                                ) : (
                                    <div className="row g-3">
                                        {visible.map((item, i) => {
                                            const colors = this.getMarginColor(item.DiscountMarkup)
                                            return (
                                                <div key={i} className="col-12 col-md-6 col-xl-4">
                                                    <div
                                                        onDoubleClick={() => this.EnableMarginPrice('priceMarginProdLine_' + item.ProductLineDesc)}
                                                        title="Double-click to edit · Enter to save"
                                                        style={{ padding: '0.875rem 1rem', borderRadius: '10px', border: `1.5px solid ${colors.border}`, background: colors.bg, cursor: 'text', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '0.75rem', transition: 'box-shadow 0.15s' }}
                                                        onMouseEnter={e => e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)'}
                                                        onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
                                                    >
                                                        <span style={{ fontSize: '0.8375rem', fontWeight: 600, color: '#334155', lineHeight: 1.3, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={item.ProductLineDesc}>
                                                            {item.ProductLineDesc}
                                                        </span>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '3px', flexShrink: 0 }}>
                                                            <input
                                                                disabled
                                                                type="number"
                                                                id={'priceMarginProdLine_' + item.ProductLineDesc}
                                                                min={0}
                                                                step={0.01}
                                                                defaultValue={item.DiscountMarkup}
                                                                onKeyDown={this.changePriceMargin}
                                                                style={{ width: '64px', textAlign: 'center', border: `1.5px solid ${colors.border}`, borderRadius: '6px', padding: '4px 6px', fontSize: '0.9rem', fontWeight: 800, color: colors.color, background: 'white' }}
                                                            />
                                                            <span style={{ fontWeight: 700, color: colors.color, fontSize: '0.9rem' }}>%</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                )}
                            </div>

                            {/* Footer stats */}
                            <div style={{ padding: '0.75rem 1.25rem', borderTop: '1px solid #E2E8F0', background: '#F8FAFC', display: 'flex', gap: '1.5rem', alignItems: 'center' }}>
                                <span style={{ fontSize: '0.78rem', color: '#64748B' }}>{visible.length} product lines shown</span>
                                <span style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.78rem', color: '#059669' }}>
                                    <span style={{ width: 10, height: 10, borderRadius: '50%', background: '#10b981', display: 'inline-block' }}></span>≥20% healthy
                                </span>
                                <span style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.78rem', color: '#D97706' }}>
                                    <span style={{ width: 10, height: 10, borderRadius: '50%', background: '#F59E0B', display: 'inline-block' }}></span>10–19% moderate
                                </span>
                                <span style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.78rem', color: '#DC2626' }}>
                                    <span style={{ width: 10, height: 10, borderRadius: '50%', background: '#EF4444', display: 'inline-block' }}></span>&lt;10% low
                                </span>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}
